// DSP video API base. cin-dsp-be is multi-tenant; the DSP consumer targets the
// `dsp` tenant subdomain. Override via REACT_APP_DSP_API.
const API_BASE =
  process.env.REACT_APP_DSP_API || "http://dsp.localhost:4021/api/videos";

export const API = {
  publicVideos: `${API_BASE}/byagreement`,
  ACVideos: `${API_BASE}/byagreement`,
};

// cin-dsp-be is one service; the tenant/party is selected by subdomain. Build the
// origin for a given org from a single host (default local). Replaces the old
// per-party prod IP + port-per-party scheme.
const TENANT_HOST = process.env.REACT_APP_TENANT_HOST || "localhost:4021";
const TENANT_PROTOCOL = process.env.REACT_APP_TENANT_PROTOCOL || "http";
export const tenantOrigin = (org: string) =>
  `${TENANT_PROTOCOL}://${org}.${TENANT_HOST}`;
